export default {
    binCell: {
        ariaLabel: 'Bin {index}, {start} to {end}, value {value} MWh',
    },
}
